import { render, staticRenderFns } from "./WorldViewForm.vue?vue&type=template&id=5303031a&scoped=true"
import script from "./WorldViewForm.vue?vue&type=script&lang=ts"
export * from "./WorldViewForm.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewForm.vue?vue&type=style&index=0&id=5303031a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303031a",
  null
  
)

export default component.exports